import styled from 'styled-components';

export default styled.div`
    .w2g-alert {
        margin-top: var(--spacing-8);
    }
`;
